import React from 'react';
import { Clock, Video } from 'lucide-react';
import Button from '../../../components/ui/Button';

const SessionCard = ({ session }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4">
          <img
            src={session.teacherImage}
            alt={session.teacherName}
            className="w-12 h-12 rounded-full"
          />
          <div>
            <h3 className="font-medium">{session.subject}</h3>
            <p className="text-sm text-gray-600">with {session.teacherName}</p>
          </div>
        </div>
        <Button size="sm">Join Session</Button>
      </div>
      
      <div className="flex items-center space-x-4 text-sm text-gray-600">
        <div className="flex items-center">
          <Clock className="h-4 w-4 mr-2" />
          {session.time} ({session.duration})
        </div>
        <div className="flex items-center">
          <Video className="h-4 w-4 mr-2" />
          Online Session
        </div>
      </div>
    </div>
  );
};

export default SessionCard;